import React from 'react';
import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';
import type { IAnimPreviewFeature } from './anim-preview-interface';
import { config } from './config';
import AnimPreviewPanel from '@src/framework/frame-pc/components/anim-preview-panel';
import { IEditorAnimPreviewManager } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/editor-state-animation/editor-anim-preview-manager.interface';

@Feature()
export class AnimPreviewFeature extends BaseToolbarFeature implements IAnimPreviewFeature {
    public id = config.id;
    public config = config;
    public constructor() {
        super();
    }

    public onClick() {
        this.getEditorAnimPreviewManager()?.previewFromBeginning();
        const animPreviewManager = this.getEditorAnimPreviewManager();
        if (animPreviewManager?.isAnimPreviewing) {
            animPreviewManager.cancelPreviewingAnims();
        } else {
            animPreviewManager?.previewFromBeginning();
        }
    }

    public getAnimPreviewPanel() {
        return <AnimPreviewPanel />;
    }

    private getEditorAnimPreviewManager(): IEditorAnimPreviewManager | undefined {
        return this.getAppService().viewableServiceLayer?.getEditorAnimPreviewManager();
    }
}
